
import "./SearchBar.css";
import crossIcon from "../../assets/img/icons/cross-svgrepo-com.svg";
import whiteSearchIcon from "../../assets/img/icons/icons8-search.svg";
interface SearchBarProps {
   searchValue: string;
   searchOnChange: React.ChangeEventHandler<HTMLInputElement>;
   clearValChange?: () => void;  // Function to clear search value

}
const SearchBar: React.FC<SearchBarProps> = ({ searchValue, searchOnChange, clearValChange }) => {

   // Function to handle the clear action
   const handleClear = () => {
      if (clearValChange) {
         clearValChange();  // Call the function passed from the parent to clear the search value
      }
   };



   return (

      <div className="wrap align-content-center w-100" >
         <div className="search">
            <input value={searchValue} type="text" className="searchTerm ps-2" placeholder="Search here.." onChange={searchOnChange} />
            {
               searchValue && <img src={crossIcon} alt="cross" className="cross-icon" onClick={handleClear} />
            }

            <button type="submit" className="searchButton">
               <i className="d-flex justify-content-center align center">
                  <img src={whiteSearchIcon} alt="search" style={{ height: "25px", width: "25px" }} />
               </i>

            </button>
         </div>
      </div>

   )
};
export default SearchBar;